import { Box, Flex } from '@chakra-ui/react';
import React from 'react';

import config from 'configs/app';
import HeroBanner from 'ui/home/HeroBanner';
import ChainIndicators from 'ui/home/indicators/ChainIndicators';
import LatestArbitrumL2Batches from 'ui/home/latestBatches/LatestArbitrumL2Batches';
import LatestZkEvmL2Batches from 'ui/home/latestBatches/LatestZkEvmL2Batches';
import LatestBlocks from 'ui/home/LatestBlocks';
import Stats from 'ui/home/Stats';
import Transactions from 'ui/home/Transactions';
import SurfaceCard from 'ui/shared/SurfaceCard';

const rollupFeature = config.features.rollup;

const Home = () => {
  const leftWidget = (() => {
    if (rollupFeature.isEnabled && !rollupFeature.homepage.showLatestBlocks) {
      switch (rollupFeature.type) {
        case 'zkEvm':
          return <LatestZkEvmL2Batches/>;
        case 'arbitrum':
          return <LatestArbitrumL2Batches/>;
      }
    }

    return <LatestBlocks/>;
  })();

  return (
    <Box as="main">
      <HeroBanner/>
      <Flex flexDir={{ base: 'column', lg: 'row' }} columnGap={ 4 } rowGap={ 4 } mt={ 8 } _empty={{ mt: 0 }}>
        <Stats/>
        <ChainIndicators/>
      </Flex>
      <Flex mt={ 8 } direction={{ base: 'column', lg: 'row' }} columnGap={ 4 } rowGap={ 4 } alignItems={{ lg: 'stretch' }}>
        { /* Desktop: split area into 50/50 columns */ }
        <Box flex={ 1 } minW={ 0 } display="flex">
          <SurfaceCard p={ 3 } w="full" h={{ lg: 'full' }}>
            { leftWidget }
          </SurfaceCard>
        </Box>
        <Box flex={ 1 } minW={ 0 } display="flex">
          <SurfaceCard p={ 3 } w="full" h={{ lg: 'full' }}>
            <Transactions/>
          </SurfaceCard>
        </Box>
      </Flex>
    </Box>
  );
};

export default Home;
